import { BarChartOutlined } from "@ant-design/icons";
import {
  List as ListIcon,
  ManageHistory,
  Email,
  ManageAccounts,
  Settings,
  AdminPanelSettings,
} from "@mui/icons-material";
import { MANUSCRIPT_URL } from "manuscript/constants";
import {
  MANUSCRIPT_MY_URL,
  MANUSCRIPT_ALL_URL,
} from "manuscript/constants/route";
import { SETTING_URL } from "setting/constants";
import { PROFILE_URL } from "profile/constants/url";
import {
  MAIL_TEMPLATE_URL,
  USER_ASSIGNMENT_URL,
  MANAGER_SETTING_URL,
} from "setting/constants/route";
import i18n from "base/lib/i18n";

export const getSettingRoutes = () => {
  return {
    // text: "관리자 설정",
    text: i18n.t("menu_admin_setting"),
    icon: ManageHistory,
    href: `/${SETTING_URL}`,
    cantNavigate: true,
    isExpand: true,
    subLinks: [
      {
        // text: "메일 템플릿",
        text: i18n.t("menu_email_template"),
        href: MAIL_TEMPLATE_URL,
        icon: Email,
      },
      {
        // text: "분야별 담당자 지정",
        text: i18n.t("menu_reviewer_setting"),
        href: USER_ASSIGNMENT_URL,
        icon: ManageAccounts,
      },
      {
        // text: "분야별 담당자 지정",
        text: i18n.t("menu_manager_setting"),
        href: MANAGER_SETTING_URL,
        icon: AdminPanelSettings,
      },
    ],
  };
};

export const getMainRoutes = () => {
  return [
    {
      // text: "대시보드",
      text: i18n.t("menu_dashboard"),
      href: "/dashboard",
      icon: BarChartOutlined,
    },
    {
      // text: "원고 투고 목록",
      text: i18n.t("menu_catetory_setting"),
      href: `/${MANUSCRIPT_URL}`,
      icon: ListIcon,
      isExpand: true,
      cantNavigate: true,
      subLinks: [
        {
          // text: "내 분야 원고 목록",
          text: i18n.t("menu_my_manuscripts"),
          href: MANUSCRIPT_MY_URL,
          icon: ListIcon,
          isExpand: false,
        },
        {
          // text: "모든 원고 목록",
          text: i18n.t("menu_all_manuscripts"),
          href: MANUSCRIPT_ALL_URL,
          icon: ListIcon,
          isExpand: true,
          subLinks: [],
        },
      ],
    },
    {
      text: i18n.t("menu_profile_setting"),
      href: `/${PROFILE_URL}`,
      icon: Settings,
    },
  ];
};
